import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { authGuard } from '@/auth/authGuard';
import { recordNav, labelForRoute } from '@/lib/navHistory';

const routes: RouteRecordRaw[] = [
  // Public landing page — also the post-logout target (see MSAL config). Authenticated
  // visitors are bounced to /groups by LandingView itself, so deep-linking to / while
  // signed in still drops you into the app.
  { path: '/', component: () => import('@/views/LandingView.vue') },
  { path: '/groups', component: () => import('@/views/GroupsListView.vue'), meta: { requiresAuth: true } },
  { path: '/groups/:group', component: () => import('@/views/GroupEditorView.vue'), meta: { requiresAuth: true } },
  {
    path: '/groups/:group/environments/:env',
    component: () => import('@/views/GroupEditorView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/groups/:group/projects/:project',
    component: () => import('@/views/ConfigEditorView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/groups/:group/projects/:project/environments/:env',
    component: () => import('@/views/ConfigEditorView.vue'),
    meta: { requiresAuth: true },
  },
  { path: '/secrets', component: () => import('@/views/SecretsView.vue'), meta: { requiresAuth: true } },
  { path: '/api-keys', component: () => import('@/views/ApiKeysView.vue'), meta: { requiresAuth: true } },
  { path: '/services', component: () => import('@/views/ServicesView.vue'), meta: { requiresAuth: true } },
  {
    path: '/services/:name',
    component: () => import('@/views/ServiceEditorView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/services/:name/environments/:env',
    component: () => import('@/views/ServiceEditorView.vue'),
    meta: { requiresAuth: true },
  },
  { path: '/environments', component: () => import('@/views/EnvironmentsView.vue'), meta: { requiresAuth: true } },
  { path: '/audit', component: () => import('@/views/AuditView.vue'), meta: { requiresAuth: true } },
  { path: '/backup', component: () => import('@/views/BackupView.vue'), meta: { requiresAuth: true } },
  { path: '/server-info', component: () => import('@/views/ServerInfoView.vue'), meta: { requiresAuth: true } },
  { path: '/profile', component: () => import('@/views/ProfileView.vue'), meta: { requiresAuth: true } },
  { path: '/unauthorized', component: () => import('@/views/UnauthorizedView.vue') },
];

const router = createRouter({
  history: createWebHistory('/admin/'),
  routes,
});

router.beforeEach(authGuard);

// Record every successful navigation to an authenticated app view. requiresAuth gates
// out '/' (landing) and '/unauthorized', which carry no meta. afterEach runs only on
// confirmed navigations, so a guard-cancelled redirect never gets logged.
router.afterEach((to) => {
  if (to.meta?.requiresAuth) {
    recordNav(to.fullPath, labelForRoute(to));
  }
});

export default router;
